import {
  ControlState,
  IApp,
  IBaseControlOptions,
  IDropdownOption,
  IItem,
  ILabel,
  IPlugin,
  IPluginPanelOptions,
  IProjectPageParam,
  IReference,
  ISearchResult,
  IStringNumberMap,
  IStringStringArrayMap,
  registerPlugin,
  XRGetProject_StartupInfo_ListProjectAndSettings,
  XRGetTodosAck,
  XRGroupPermissionType,
  XRTodo,
} from 'matrix-requirements-sdk/client';

import { sdkInstance } from './Instance';

export type {
  ITrainingAnalysis,
  ITrainingAnalysisUsers,
  ITrainingDone,
  ITrainingCellStatus,
};
export { ITrainingFilter, ETrainingStatus, TrainingTable };

const ml = sdkInstance.ml;
const app = sdkInstance.app as IApp;
const matrixsdk = sdkInstance.matrixsdk;
const globalMatrix = sdkInstance.globalMatrix;
const UIToolsConstants = sdkInstance.UIToolsConstants;
const matrixSession = sdkInstance.matrixSession;
//@ts-ignore
const NotificationsBL = sdkInstance['NotificationsBL'];
// @ts-ignore
const refLinkStyle = sdkInstance['refLinkStyle'];
// @ts-ignore
const refLinkTooltip = sdkInstance['refLinkTooltip'];

// TODO(modules): why is this a class?
interface ITrainingFilter {
  userRaw: string[]; // user and groups selected as filter
  user: string[]; // actual users in filter
  itemInfo: string; // can be item id (PROC-12) item title (design) or SOP (capa sop)
  // or these, all false == all -> // only show users / PROCs with
  new: boolean; // needs training
  due: boolean; // training planned
  overdue: boolean; // overdue training
  ok: boolean; // all well trained
  none: boolean; // no training needed
  //
  overdueAfter: string; // show waiting training notification's as overdue after n days
  retrainingAfter: string; // show trainings as need to be re-done after n days
}

interface ITrainingAnalysis {
  title: string; // title of process
  hasTraining: boolean; // set to true if there's a training defined for the process
  users: { [key: string]: ITrainingAnalysisUsers }; // info per user
  labels: string[]; // labels set
}

interface ITrainingAnalysisUsers {
  /** true if there is an open training notification */
  thereIsATraining: boolean;
  /** if thereIsATraining number of days since it was created */
  theTrainingExistsSinceDays: number;
  /** true thereIsATraining if the training notification is overdue */
  theTrainingIsOverdue: boolean;
  /** true if there should be a training (either because there never has been one or there was no retraining) */
  thereShouldBeATraining: boolean;
  /** info about each training done */
  trainingsDone: ITrainingDone[];
  /** if there was a completed training, how many days ago the last training was completed */
  lastTrainingAgeDays: number;
  /** if there was a completed training, when last training was completed */
  lastTrainingDate: Date;
}

interface ITrainingDone {
  trainingCreated: string; // creation date
  trainingDone: string; // training date
  trainingDays: number; // how long it took after creation until training was done
  trainingOverdue: boolean; // true if training was overdue
}

interface ITrainingCellStatus {
  classes: string; // formatting
  text: string; // text to show in cell
  verbose: string; // tooltip with more info
}

enum ETrainingStatus {
  notNeeded, // no training required
  needed, // needed, but not created,
  due, // created
  overdue, // created and overdue
  done, // training done
}
class TrainingTable {
  //@ts-ignore
  private vscroll: JQuery;
  //@ts-ignore
  protected ivscroll: JQuery;
  //@ts-ignore
  private hscroll: JQuery;
  //@ts-ignore
  protected ihscroll: JQuery;

  //@ts-ignore
  protected filterBox: JQuery;
  //@ts-ignore
  private mainTable: JQuery;

  //@ts-ignore
  private leftTable: JQuery;
  //@ts-ignore
  private leftContainer: JQuery;
  //@ts-ignore
  protected leftBody: JQuery;

  //@ts-ignore
  protected topTable: JQuery;
  //@ts-ignore
  private topContainer: JQuery;
  //@ts-ignore
  protected headerRow: JQuery;

  //@ts-ignore
  protected accessTable: JQuery;
  //@ts-ignore
  private accessContainer: JQuery;
  //@ts-ignore
  protected accessBody: JQuery;
  //@ts-ignore
  protected topLeft: JQuery;

  constructor() {}

  protected destroyTable() {
    //@ts-ignore
    this.mainTable = undefined;
    //@ts-ignore
    this.accessTable = undefined;
    //@ts-ignore
    this.accessBody = undefined;
    //@ts-ignore
    this.accessContainer = undefined;
  }
  // UI timer to set up table in background
  protected intiTableTimer: number | undefined;

  protected createMainContainer(place: JQuery) {
    // prepare the box
    this.filterBox = $("<div style='padding-left: 10px;'>").appendTo(place);

    this.mainTable = $("<div class='' style='overflow:hidden;'>");
    place.append(this.mainTable);
    let ut = $("<table class='table'>").appendTo(this.mainTable);
    let lt = $('<td>');
    let rt = $("<td style='width:100%'>");
    let lb = $("<td style='max-width: 500px;width: 500px;'>");
    let rb = $('<td>');
    ut.append($('<tr>').append(lt).append(rt));
    ut.append($('<tr>').append(lb).append(rb));

    // ************************************
    // top navigation row -> headerRow
    // ************************************

    this.topContainer = $("<div style='overflow:hidden;'>").appendTo(rt);
    this.topTable = $('<table>').appendTo(this.topContainer);
    let projectHead = $('<thead>').appendTo(this.topTable);
    this.headerRow = $("<tr class=''>").appendTo(projectHead);
    this.topLeft = $("<div class='trainingFilterBox'>").appendTo(lt);
    $(
      `<div id='noTrainingMatch' class='inlineHelp' style='display:none'>No trainings match the filter</div>`,
    ).appendTo(lt);

    // ************************************
    // left column: users
    // ************************************

    this.leftContainer = $("<div style='overflow:hidden;'>").appendTo(lb);
    this.leftTable = $("<table style='width:500px'>").appendTo(
      this.leftContainer,
    );
    this.leftBody = $('<tbody>').appendTo(this.leftTable);

    // ************************************
    // main: access
    // ************************************

    this.accessContainer = $("<div style='overflow:hidden;'>").appendTo(rb);
    this.accessTable = $("<table id='qmsTable' class='' >").appendTo(
      this.accessContainer,
    );
    this.accessBody = $('<tbody>').appendTo(this.accessTable);
  }

  // create a box for tooltip for cells
  protected initTooltipBox(onShow: (cell: JQuery) => string) {
    let that = this;

    let infoBox = $("<div class='ua_who' style='top:-100px;'>").appendTo(
      app.itemForm,
    );

    let lastCell: JQuery;
    this.accessTable
      ?.mousemove((event) => {
        let cell = $('th:hover, td:hover', this.accessTable);
        if (!cell.is(lastCell)) {
          lastCell = cell;

          // remove
          $('.ua_hover', this.accessTable).removeClass('ua_hover');
          $('.ua_hoverbold', this.accessTable).removeClass('ua_hoverbold');
          infoBox.css('top', '-10000px');
          infoBox.hide();

          // show mouseover in column
          $(
            'td:nth-child(' + (cell.index() + 1) + ')',
            this.accessTable,
          ).addClass('ua_hover');
          // and highlight row
          $(
            'tr:nth-child(' + (cell.parent().index() + 1) + ') > td',
            this.accessTable,
          ).addClass('ua_hover');

          // ask for text and show it
          let popover = onShow($(cell));

          if (popover) {
            infoBox.html(popover);
            let posOpt = event.clientX + 0 - app.itemForm.offset().left;
            let posMax = $('#itemDetails').width() - infoBox.width() - 20;
            infoBox.css(
              'top',
              event.clientY -
                infoBox.height() -
                10 -
                app.itemForm.offset().top +
                'px',
            );
            infoBox.css('left', Math.min(posOpt, posMax) + 'px');
            infoBox.show();
          }
        }
      })
      .mouseleave(() => {
        $('.ua_hover', this.accessTable).removeClass('ua_hover');
        $('.ua_hoverbold', this.accessTable).removeClass('ua_hoverbold');
        infoBox.css('top', '-10000px');
        infoBox.hide();
      });
  }

  // place change menu for a cell
  protected placeChangeMenu(uio: JQuery, cell: JQuery) {
    let pos = cell.offset();
    pos.left -= app.itemForm.offset().left;
    pos.top -= app.itemForm.offset().top;

    let ww = $(window).width();
    let wh = $(window).height();
    let dw = uio.outerWidth();
    let dh = uio.outerHeight();
    let cw = cell.outerWidth();
    let ch = cell.outerHeight();

    if (pos.top + ch + dh + 10 > wh) {
      pos.top = pos.top - dh + 10;
    } else {
      pos.top += ch - 10;
    }
    if (pos.left + cw + dw + 10 > ww) {
      pos.left = pos.left - dw + 10;
    } else {
      pos.left += cw - 10;
    }
    uio.css('top', pos.top + 'px');
    uio.css('left', pos.left + 'px');
    uio.css('display', 'block');
  }

  // init and handle menu
  protected initCellMenu(change: (cell: JQuery, option: string) => void) {
    let that = this;

    // ************************************
    // create cell menu
    // ************************************

    let dropdown = $(`<div  class="ua_dropdown_content">
            <a class='trainingReminder' data-fct="reminder" href="#">send reminder</a>
            <a class='trainingCreate' data-fct="create"  href="#">create new training</a>
            <a class='trainingDelete' data-fct="delete"  href="#">mark training as done</a>
            <a class='trainingDelete' data-fct="deleteforce"  href="#">delete training</a>
        </div>`);

    dropdown.appendTo(app.itemForm);

    // ************************************
    // add click events for menu options
    // ************************************

    $('a', dropdown).click((event) => {
      // hide menu
      dropdown.css('display', 'none');

      // get clicked option and cell
      let fct = $(event.delegateTarget).data('fct');
      let cell = dropdown.data('cell');

      change(cell, fct);

      // stop events
      if (event.preventDefault) event.preventDefault();
      return false;
    });

    // ************************************
    // add menu to table
    // ************************************

    that?.accessTable.mouseenter(() => {
      $('.trainingReminder').hide();
      $('.trainingCreate').hide();
      $('.trainingDelete').hide();
    });
    this.accessTable.click((event) => {
      // hide menu if open
      dropdown.css('display', 'none');

      if (event.target.nodeName.toLowerCase() != 'td') {
        // not sure on what else someone might click
        return;
      }

      // get the cell for which the menu is opened
      let cell = $(event.target);
      dropdown.data('cell', cell);
      // manipulate the menu (for tables with projects)
      let needTraining = cell.hasClass('needTraining');
      let hasTraining = cell.hasClass('openTraining');
      let hadTraining = cell.hasClass('hadTraining');

      if (hasTraining) {
        $('.trainingReminder').show();
        $('.trainingDelete').show();
        $('.trainingCreate').hide();
        this.placeChangeMenu(dropdown, cell);
      } else if (needTraining) {
        $('.trainingReminder').hide();
        $('.trainingDelete').hide();
        $('.trainingCreate').show();
        this.placeChangeMenu(dropdown, cell);
      } else if (hadTraining) {
        $('.trainingReminder').hide();
        $('.trainingDelete').hide();
        $('.trainingCreate').show();
        this.placeChangeMenu(dropdown, cell);
      }

      if (event.preventDefault) event.preventDefault();
      return false;
    });
  }

  protected hideMenu() {
    $('.ua_dropdown_content').hide();
  }

  protected scrollTop() {
    this.leftTable.css('margin-top', 0);
    this.accessTable.css('margin-top', 0);
    this.vscroll.scrollTop(0);
  }
  protected scrollLeft() {
    this.hscroll.scrollLeft(0);
  }

  // make table scrollable
  protected initTableScrolling(where: JQuery, paddingBottom: number) {
    let that = this;

    // ************************************
    // create scrollbars
    // ************************************
    if (this.vscroll != undefined) {
      this.vscroll.remove();
    }
    if (this.ivscroll != undefined) {
      this.ivscroll.remove();
    }
    if (this.hscroll != undefined) {
      this.hscroll.remove();
    }
    if (this.ihscroll != undefined) {
      this.ihscroll.remove();
    }

    this.vscroll = $(
      '<div style="overflow-y: auto;width: 30px;position: absolute;right: 10px;">',
    ).appendTo(where);
    this.ivscroll = $('<div style="">').appendTo(this.vscroll);
    this.hscroll = $(
      '<div style="overflow-x: auto;height: 30px;position: absolute;">',
    ).appendTo(where);
    this.ihscroll = $('<div style="height:8px">').appendTo(this.hscroll);

    // reset height of left container
    this.leftContainer.css('height', '');
    // ************************************
    // resize everything
    // ************************************

    // the whole user access table must be height of horizontal project list + height of vertical user list + some padding but it needs to fit on screen
    let top = this.mainTable.position().top;
    let countsHeight = paddingBottom ? paddingBottom : 0; // for stuff under table
    let offset = paddingBottom ? 10 : 0;
    if (this.leftContainer.height() == 0) {
      $('#noTrainingMatch').show();
      return;
    }
    this.mainTable.css(
      'height',
      Math.min(
        app.itemForm.height() - top - countsHeight,
        this.leftContainer.height() + this.topContainer.height() + 60,
      ) + 'px',
    );
    $('#noTrainingMatch').hide();

    // set width of user selection to it's needed size, to avoid resizing when filtering
    // this.leftContainer.width(this.leftContainer.width());
    this.topContainer.width(
      this.mainTable.width() - this.leftContainer.width() - 10,
    );
    this.accessContainer.width(
      this.mainTable.width() - this.leftContainer.width() - 30,
    );
    this.accessContainer.height(
      this.mainTable.height() - this.topContainer.height() - 60,
    ); // 60 is height of Notes: ...
    this.leftContainer.height(
      this.mainTable.height() - this.topContainer.height() - 60,
    );

    let tpos =
      this.accessContainer.offset().top -
      this.accessContainer.offsetParent().offset().top;
    this.vscroll.css('top', offset + tpos + 'px');
    this.vscroll.height(this.accessContainer.height());
    this.vscroll.scroll(() => {
      this.accessTable.css('margin-top', -this.vscroll.scrollTop());
      this.leftTable.css('margin-top', -this.vscroll.scrollTop());
    });
    this.ivscroll.height($('#qmsTable').height());

    let hpos =
      this.accessContainer.offset().left -
      this.accessContainer.offsetParent().offset().left;
    this.hscroll.css('top', 12 + tpos + this.accessContainer.height() + 'px');
    this.hscroll.css('left', hpos + 'px');
    this.hscroll.width(this.accessContainer.width());
    this.hscroll.scroll(() => {
      this.hideMenu();
      this.accessTable.css('margin-left', -this.hscroll.scrollLeft());
      this.topTable.css('margin-left', -this.hscroll.scrollLeft());
    });
    this.ihscroll.width(this.topTable.width());

    this.mainTable.scroll(() => {
      this.hideMenu();
    });

    // ************************************
    // support scrolling with mousewheel
    // ************************************
    this.accessTable.bind('mousewheel', (e: any) => {
      this.scrollFunction(e);
    });
    this.leftContainer.bind('mousewheel', (e: any) => {
      this.scrollFunction(e);
    });
  }

  private scrollFunction(e: any) {
    let maxScroll = this.ivscroll.height() - this.vscroll.height();
    let currentScroll = this.vscroll.scrollTop();
    if (e.originalEvent.wheelDelta / 120 > 0) {
      this.vscroll.scrollTop(Math.max(0, currentScroll - 20));
    } else {
      this.vscroll.scrollTop(Math.min(maxScroll, currentScroll + 20));
    }
  }
}

interface IItemTodoMap {
  [key: string]: XRTodo[];
}
// allows to specify which columns / rows are hidden;
interface IHiding {
  rows: number[];
  columns: number[];
}

class QMSTraining extends TrainingTable implements IPlugin {
  // ****************************************
  // standard plugin interface
  // ****************************************

  public isDefault = true;
  //@ts-ignore
  private panel: JQuery;
  //@ts-ignore
  private data: JQuery;

  //@ts-ignore
  private trainingFilter: ITrainingFilter;

  //@ts-ignore
  private toolBar: JQuery;

  // raw data before analysis
  //@ts-ignore
  private processData: ISearchResult[];
  //@ts-ignore
  private fieldsWithTrainees: number[];
  //@ts-ignore
  private labelsCatsWithTraining: ILabel[];
  //@ts-ignore
  private trainingTodos: XRTodo[];
  //@ts-ignore
  private trainingTodosPerItem: IItemTodoMap;
  //@ts-ignore
  private userGroups: XRGroupPermissionType[];

  // Progress Tuning
  private PROGRESS_PROC = 10;
  private PROGRESS_NOTIFICATION = 10;
  private PROGRESS_MATH = 30;
  private PROGRESS_UI = 30;
  private PROGRESS_FILTER = 20;

  private PROGRESS_START = 10;
  private PROGRESS_GET1 = 40;
  private PROGRESS_GET2 = 70;
  private PROGRESS_ANALYSIS = 80;
  private PROGRESS_RENDER = 90;

  // the list of users
  //@ts-ignore
  private users: string[];
  // all info about processes and trainings
  //@ts-ignore
  private analysis: { [key: string]: ITrainingAnalysis };
  // items without trainings
  //@ts-ignore
  private itemsWithoutNeedForTraining: string[];
  // items with training
  //@ts-ignore
  private itemsWithNeedForTraining: string[];
  // remember what was previously hidden
  //@ts-ignore
  private lastHiding: IHiding;

  constructor() {
    super();
  }

  initItem(_item: IItem, _jui: JQuery) {}

  initServerSettings(
    serverSettings: XRGetProject_StartupInfo_ListProjectAndSettings,
  ) {}

  updateMenu(ul: JQuery, hook: number) {}

  supportsControl(fieldType: string): boolean {
    return false;
  }

  createControl(ctrl: JQuery, options: IBaseControlOptions) {}

  initProject() {
    //@ts-ignore
    this.userGroups = undefined;
  }

  destroy(): void {
    this.destroyTable();
    this.intiTableTimer = undefined;
    this.accessBody.html('');
    this.processData = [];
    this.fieldsWithTrainees = [];
    this.labelsCatsWithTraining = [];
    this.trainingTodos = [];
    this.trainingTodosPerItem = {};

    this.userGroups = [];

    this.analysis = {};
    this.itemsWithoutNeedForTraining = [];
    this.itemsWithNeedForTraining = [];
    //@ts-ignore
    this.lastHiding = undefined;
  }

  // add one new project page to  the tree
  getProjectPagesAsync(): Promise<IProjectPageParam[]> {
    return new Promise((resolve, reject) => {
      let that = this;
      var pages: IProjectPageParam[] = [];

      if (matrixSession.isQMSProject(matrixSession.getProject())) {
        pages.push({
          id: 'TRAINING',
          icon: 'fal fa-chalkboard-teacher',
          title: 'QMS Training',
          folder: 'QMS',
          order: 1000,
          usesFilters: false,
          render: (options: IPluginPanelOptions) =>
            this.renderProjectPage(options),
        });
      }

      resolve(pages);
    });
  }

  // project pages show in the top in Projects, Reports and Documents
  private renderProjectPage(options: IPluginPanelOptions) {
    let that = this;

    document.title = 'QMS Training - ' + matrixSession.getProject();

    //@ts-ignore
    if (options.controlState === sdkInstance['ControlState'].Print) {
      return;
    }

    // set filter details
    this.trainingFilter = {
      user: [],
      userRaw: [],
      ok: false,
      none: true,
      new: false,
      due: false,
      overdue: false,
      overdueAfter: globalMatrix.projectStorage.getItemDefault(
        'QMSoverdueAfter',
        '14',
      ),
      retrainingAfter: globalMatrix.projectStorage.getItemDefault(
        'QMSretrainingAfter',
        '365',
      ),
      itemInfo: '',
    };

    options.control.html('');
    this.panel = $(
      '<div id="qmsTrainingPanel" class="panel-body-v-scroll fillHeight" style="padding: 0 12px;">',
    );

    options.control.prepend(
      ml.UI.getPageTitle(
        'QMS Training ',
        () => {
          return this.panel;
        },
        () => {
          this.initTableScrolling($('#QMSTrainingData'), 0);
        },
      ),
    );

    this.panel.appendTo(options.control);
    this.render();
  }

  private goFullScreen(): JQuery {
    return $('#qmsTrainingPanel');
  }

  private updateSize() {
    let that = this;
  }

  protected async cellMenuAction(cell: JQuery, cmd: string) {
    let that = this;

    if (cell) {
      let user = cell.data('user');
      let process = cell.data('item');

      switch (cmd) {
        case 'reminder':
          let cannedMessage = ml.Mail.getCannedMessage(
            'training_reminder',
            user,
            process,
          );

          let message =
            cannedMessage +
            `<ul>
                        <li><a href='${globalMatrix.matrixBaseUrl}/pub/${matrixSession.getProject()}/?show=${process}'>${process}</a>${app.getItemTitle(process)}</li>
                        </ul>`;
          ml.Mail.sendMail(user, '', '', 'Training Reminder', message);
          break;
        case 'create':
          //@ts-ignore
          this.createTrainingsRec([process], null, user).then(async () => {
            ml.UI.showSuccess('Done creating training.', 1000);
            await this.analyzeProcesses();
            this.updateTrainingStatus(cell, user, process);
          });

          break;
        case 'delete':
        case 'deleteforce':
          let todos = this.trainingTodos.filter(
            (t) => t.login == user && t.itemRef == process && !t.closedAt,
          );
          if (todos.length == 1) {
            let todo = todos[0];
            let params = cmd == 'deleteforce' ? { hardDelete: 'yes' } : {};
            await restConnection.deleteServerAsync(
              matrixSession.getProject() + '/todo/' + todo.todoId,
              params,
            );
            ml.UI.showSuccess(
              cmd == 'deleteforce'
                ? 'Deleted training.'
                : 'Marked training as done',
              1000,
            );
            if (cmd === 'deleteforce') {
              // remove from cache if hard deleted
              this.trainingTodos = this.trainingTodos.filter(
                (t) => t.login != user || t.itemRef !== process || t.closedAt,
              );
            } else {
              // mark as done if marked training as done
              todo.closedAt = new Date().toISOString();
            }
            this.mapTodosToItems();
            await this.analyzeProcesses();
            this.updateTrainingStatus(cell, user, process);

            this.mapTodosToItems();
            await this.analyzeProcesses();
            this.updateTrainingStatus(cell, user, process);
          } else {
            ml.Logger.error(
              `there's no current training for user ${user} which can be deleted`,
            );
            // reload page
            window.location.href = window.location.href;
          }

          break;
      }
    }
  }

  private async render(): Promise<void> {
    this.panel.empty();
    let div = $('<div/>').appendTo(this.panel);
    let div2 = $('<div/>').appendTo(div);
    $("<button class='btn btn-item'><span class='fal fa-cog' /></button>")
      .appendTo('.toolbarButtons')
      .click(() => {
        this.showSettingsDialog();
      });

    ml.UI.BlockingProgress.Init([{ name: 'Getting Training Info' }]);
    await this.getAndAnalyzeData();
    this.panel.html('');
    this.addToolbar();
    this.data = $("<div id='QMSTrainingData' class='hideCopy'>").appendTo(
      this.panel,
    );
    this.drawTable();
  }

  // show dialog for settings (when is something overdue/needs re-training)
  private showSettingsDialog() {
    let that = this;

    let newFilter = ml.JSON.clone(this.trainingFilter);

    let filters = $("<div class='hideCopy'>");
    $("<input type='text' style='position: absolute;top: -10000px;'>").appendTo(
      filters,
    );

    let dateOptions: IDropdownOption[] = [
      { id: '7', label: '1 week' },
      { id: '14', label: '2 weeks' },
      { id: '21', label: '3 weeks' },
      { id: '30', label: '1 month' },
      { id: '61', label: '2 months' },
      { id: '91', label: '3 months' },
      { id: '182', label: '6 months' },
      { id: '365', label: '1 year' },
      { id: '730', label: '2 years' },
      { id: '1095', label: '3 years' },
      { id: '1825', label: '5 years' },
      { id: '3650', label: '10 years' },
    ];
    ml.UI.addDropdownToValue(
      filters,
      'Mark trainings as overdue after',
      newFilter,
      'overdueAfter',
      dateOptions,
      false,
      false,
      () => {
        globalMatrix.projectStorage.setItem(
          'QMSoverdueAfter',
          newFilter.overdueAfter,
        );
      },
    );
    ml.UI.addDropdownToValue(
      filters,
      'Re-training after last training',
      newFilter,
      'retrainingAfter',
      dateOptions,
      false,
      false,
      () => {
        globalMatrix.projectStorage.setItem(
          'QMSretrainingAfter',
          newFilter.retrainingAfter,
        );
      },
    );

    // dialog

    let dlg = $('<div>').appendTo($('body'));

    ml.UI.showDialog(
      dlg,
      'Settings',
      filters,
      -730,
      -440,
      [
        {
          text: 'Apply',
          class: 'btnDoIt',
          click: () => {
            filters.html('').append(ml.UI.getSpinningWait('updating view...'));
            ml.UI.setEnabled(dlg.parent().find('button'), false);
            this.trainingFilter = newFilter;
            dlg.dialog('close');
            window.setTimeout(async () => {
              await this.updateTrainings();
              this.updateVisibility();
            }, 1);
          },
        },
        {
          text: 'Cancel',
          class: 'btnCancelIt',
          click: () => {
            dlg.dialog('close');
          },
        },
      ],
      UIToolsConstants.Scroll.None,
      false,
      false,
      () => {
        dlg.remove();
      },
      () => {},
      () => {},
    );
  }

  private addFilters() {
    let that = this;

    let status = $("<div class='trainingFilterLeft'>").appendTo(this.topLeft);

    $(
      `<div class="checkbox" style="margin:0"><label><input data-filter="ok" type="checkbox" ${this.trainingFilter.ok ? '' : 'checked'}> training done &#10004;</label></div>`,
    ).appendTo(status);
    $(
      `<div class="checkbox" style="margin:0" ><label><input data-filter="new" type="checkbox" ${this.trainingFilter.new ? '' : 'checked'}> need (re)-training ( )</label></div>`,
    ).appendTo(status);
    $(
      `<div class="checkbox" style="margin:0" ><label><input data-filter="due" type="checkbox" ${this.trainingFilter.due ? '' : 'checked'}> training pending !</label></div>`,
    ).appendTo(status);
    $(
      `<div class="checkbox" style="margin:0" ><label><input data-filter="overdue" type="checkbox" ${this.trainingFilter.overdue ? '' : 'checked'}> training overdue !!</label></div>`,
    ).appendTo(status);
    $(
      `<div class="checkbox" style="margin:0" ><label><input data-filter="none" type="checkbox" ${this.trainingFilter.none ? '' : 'checked'}> no need for training</label></div>`,
    ).appendTo(status);

    $("input[type='checkbox']", status).change(
      async (event: JQueryMouseEventObject) => {
        let filter = $(event.delegateTarget);
        if (filter.is(':checked')) {
          (<any>this.trainingFilter)[filter.data('filter')] = false;
        } else {
          (<any>this.trainingFilter)[filter.data('filter')] = true;
        }
        ml.UI.BlockingProgress.Init([{ name: 'Updating Table' }]);
        ml.UI.BlockingProgress.SetProgress(0, this.PROGRESS_RENDER);
        await this.asyncRun(() => {
          this.updateVisibility();
        });
        ml.UI.BlockingProgress.SetProgress(0, 100);
      },
    );

    let people = $("<div class='trainingFilterRight'>").appendTo(this.topLeft);
    ml.UI.SelectUserOrGroup.showMultiUserSelect(
      people,
      'Filter by User or Role',
      [],
      'Select User or Role',
      '',
      '',
      true,
      true,
      async (selection: string[]) => {
        this.trainingFilter.userRaw = selection;
        this.trainingFilter.user =
          ml.UI.SelectUserOrGroup.getUsersInSelection(selection);

        ml.UI.BlockingProgress.Init([{ name: 'Updating Table' }]);
        ml.UI.BlockingProgress.SetProgress(0, this.PROGRESS_RENDER);
        await this.asyncRun(() => {
          this.updateVisibility();
        });
        ml.UI.BlockingProgress.SetProgress(0, 100);
      },
    );
    let lastProcFilter = this.trainingFilter.itemInfo;
    ml.UI.addTextInput(
      people,
      'Filter by process or procedure',
      this.trainingFilter,
      'itemInfo',
      async () => {
        if (this.trainingFilter.itemInfo != lastProcFilter) {
          lastProcFilter = this.trainingFilter.itemInfo;

          ml.UI.BlockingProgress.Init([{ name: 'Updating Table' }]);
          ml.UI.BlockingProgress.SetProgress(0, this.PROGRESS_RENDER);
          await this.asyncRun(() => {
            this.updateVisibility();
          });
          ml.UI.BlockingProgress.SetProgress(0, 100);
        }
      },
    );
  }

  private addToolbar() {
    let that = this;

    this.toolBar = $(
      "<div class='hideCopy rowFlex controlContainer' style='padding-bottom: 8px;'>",
    ).appendTo(this.panel);
    $("<button class='btn btn-default btn-space'>")
      .appendTo(this.toolBar)
      .html('Create Training Report')
      .click((event: JQueryMouseEventObject) => {
        this.createReportWizard();
      });
    $("<button class='btn   btn-default btn-space'>")
      .appendTo(this.toolBar)
      .html('Onboard New User')
      .click((event: JQueryMouseEventObject) => {
        this.onboardUserWizard();
      });
    $("<button class='btn   btn-default btn-space'>")
      .appendTo(this.toolBar)
      .html('Create New Trainings')
      .click((event: JQueryMouseEventObject) => {
        this.createTrainingWizard();
      });
    $("<button class='btn  btn-default btn-space'>")
      .appendTo(this.toolBar)
      .html('Send Training Reminders')
      .click((event: JQueryMouseEventObject) => {
        this.sendReminderWizards();
      });
  }

  // add the table users / vs items with training results
  private async getAndAnalyzeData(): Promise<void> {
    this.users = globalMatrix.ItemConfig.getUserNames(true).map((user) => {
      return user.login;
    });
    // the this cache of the groups might be modified (when adding users to groups). When changing the project the cache is deleted see iniProject() and IC.getUserGroups() can be used
    if (!this.userGroups)
      this.userGroups = ml.JSON.clone(globalMatrix.ItemConfig.getUserGroups());

    // prepare search for items which need training
    let catsWithTraining = this.getCatsWithTrainings();

    this.labelsCatsWithTraining = ml
      .CreateNewLabelTools()
      .getLabelDefinitions(catsWithTraining);
    // user fields
    this.fieldsWithTrainees = globalMatrix.ItemConfig.getFieldsOfType('user')
      .filter((field) => {
        //@ts-ignore
        return field.field.parameterJson.needTraining;
      }) // user fields with needTraining checkbox
      .map((field) => {
        return field.field.id;
      });

    let query = catsWithTraining
      .map((pubCat) => {
        return 'category=' + pubCat;
      })
      .join(' or ');

    ml.UI.BlockingProgress.SetProgress(
      0,
      this.PROGRESS_PROC,
      'Retrieving Trainings',
    );
    let timer = new Date();
    let allNotifications = <XRGetTodosAck>(
      await restConnection.getProject(
        'todo?includeDone=1&includeAllUsers=1',
        false,
        true,
      )
    );
    console.log(
      'Got Trainings: ' + (new Date().getTime() - timer.getTime()) + 'ms',
    );
    ml.UI.BlockingProgress.SetProgress(
      0,
      this.PROGRESS_PROC + this.PROGRESS_NOTIFICATION,
      'Retrieving Process Information',
    );
    timer = new Date();
    let processData = await app.searchAsync(
      'mrql:(' + query + ')',
      '',
      true,
      this.fieldsWithTrainees.join(','),
      //@ts-ignore
      null,
      true,
      true,
      false,
      true,
    );
    console.log(
      'Got Processes: ' + (new Date().getTime() - timer.getTime()) + 'ms',
    );

    //@ts-ignore
    this.processData = processData;
    this.trainingTodos = allNotifications.todos.filter((todo: XRTodo) => {
      return todo.action.todoType == 'needTraining';
    });
    this.mapTodosToItems();
    await this.analyzeProcesses();
  }

  // to speed up the process of generating the table -> without the map it will be a ^2 process

  private mapTodosToItems() {
    this.trainingTodosPerItem = {};
    for (let todo of this.trainingTodos) {
      if (!this.trainingTodosPerItem[todo.itemRef]) {
        this.trainingTodosPerItem[todo.itemRef] = [];
      }
      this.trainingTodosPerItem[todo.itemRef].push(todo);
    }
  }

  // analyzes the processes to see which need or had trainings
  private async analyzeProcesses() {
    let that = this;

    // ************************************
    // prepare analysis
    // ************************************

    this.analysis = {};
    this.itemsWithoutNeedForTraining = [];
    this.itemsWithNeedForTraining = [];

    ml.UI.BlockingProgress.SetProgress(
      0,
      this.PROGRESS_PROC + this.PROGRESS_NOTIFICATION,
      'Analyzing Training Information',
    );
    let count = this.processData.length;
    await this.fastAsyncFor(
      'analyzeProcesses',
      count,
      1 + Math.floor(count / 5),
      (idx: number) => {
        ml.UI.BlockingProgress.SetProgress(
          0,
          this.PROGRESS_PROC +
            this.PROGRESS_NOTIFICATION +
            (this.PROGRESS_MATH * idx) / this.processData.length,
        );
        let process = this.processData[idx];
        let itemTodos = this.trainingTodosPerItem[process.itemId];
        if (!itemTodos) itemTodos = [];
        if (this.analyzeProcess(process, itemTodos)) {
          this.itemsWithNeedForTraining.push(process.itemId);
        } else {
          this.itemsWithoutNeedForTraining.push(process.itemId);
        }
      },
    );
  }

  // analyzes one processes to see which need or had trainings
  private analyzeProcess(
    itemWithData: ISearchResult,
    trainingPerItemTodos: XRTodo[],
  ) {
    let that = this;
    const oneDay = 24 * 60 * 60 * 1000;
    const today = new Date();

    // ****************************************************************************
    // check if the item needs training -> at least one training field is not empty
    // or there's already some training
    // ****************************************************************************

    if (!itemWithData.fieldVal) {
      // no values...  (e.g. for categories with no user fields)
      this.analysis[itemWithData.itemId] = {
        title: itemWithData.title,
        labels: itemWithData.labels,
        hasTraining: false,
        users: {},
      };
      return false;
    }

    // this is a proc / wi or something else which needs training
    this.analysis[itemWithData.itemId] = {
      title: itemWithData.title,
      labels: itemWithData.labels,
      hasTraining: true,
      users: {},
    };

    // get a list of users who need training
    let whoNeedsTraining: string[] = [];
    $.each(itemWithData.fieldVal, (vIdx, v) => {
      if (v.value && this.fieldsWithTrainees.indexOf(v.id) != -1) {
        // v.value is a list of users or user groups who need training
        $.each(
          ml.UI.SelectUserOrGroup.getUsersInSelection(v.value.split(',')),
          (uIdx, user) => {
            if (whoNeedsTraining.indexOf(user) == -1)
              whoNeedsTraining.push(user);
          },
        );
      }
    });

    // add all user who need training to analysis
    for (let user of whoNeedsTraining) {
      // create a default entry for the user's training for this process
      this.analysis[itemWithData.itemId].users[user] = {
        // it will either one
        thereShouldBeATraining: false,
        thereIsATraining: false,
        // details to be filled if there is a training
        theTrainingExistsSinceDays: 0,
        theTrainingIsOverdue: false,
        // details to be filled if there were trainings done
        trainingsDone: [],
        lastTrainingAgeDays: 0,
        //@ts-ignore
        lastTrainingDate: null,
      };

      // get open and done trainings of user
      let trainingUser = trainingPerItemTodos.filter((todo) => {
        return todo.login == user;
      });

      // check if there's an open training
      let openTraining = false;
      let trainingTodo = trainingUser.filter((todo) => {
        return !todo.closedAt;
      });
      if (trainingTodo.length) {
        // these are training which are currently open
        let created = new Date(trainingTodo[0].createdAt);
        let diffDays = Math.round(
          (today.getTime() - created.getTime()) / oneDay,
        );

        this.analysis[itemWithData.itemId].users[user].thereIsATraining = true;
        this.analysis[itemWithData.itemId].users[
          user
        ].theTrainingExistsSinceDays = diffDays;
        this.analysis[itemWithData.itemId].users[user].theTrainingIsOverdue =
          diffDays >= Number(this.trainingFilter.overdueAfter);

        openTraining = true;
      }

      // now analyze trainings done

      let trainingDone = trainingUser.filter((todo) => {
        return !!todo.closedAt;
      });

      if (trainingDone.length == 0) {
        // there never was a training done
        if (!openTraining) {
          // and there is none -> so the manager should create one
          this.analysis[itemWithData.itemId].users[
            user
          ].thereShouldBeATraining = true;
        }
      } else {
        // find the most recent closure date
        let closedSince = -1;
        let lastClosed: Date;
        $.each(trainingDone, (tIdx, todo) => {
          let opened = new Date(todo.createdAt);
          let closed = new Date(todo.closedAt);
          let diffDays = Math.round(
            (today.getTime() - closed.getTime()) / oneDay,
          );
          if (diffDays < closedSince || closedSince == -1) {
            lastClosed = closed;
            closedSince = diffDays;
          }
          let daysBeforeTrainingDone = Math.round(
            (closed.getTime() - opened.getTime()) / oneDay,
          );
          this.analysis[itemWithData.itemId].users[user].lastTrainingAgeDays =
            closedSince;
          this.analysis[itemWithData.itemId].users[user].lastTrainingDate =
            lastClosed;
          this.analysis[itemWithData.itemId].users[user].trainingsDone.push({
            trainingCreated: todo.createdAtUserFormat, // creation date
            trainingDone: todo.closedAtUserFormat, // training date
            trainingDays: daysBeforeTrainingDone, // how long it took after creation until training was done
            trainingOverdue:
              daysBeforeTrainingDone >=
              Number(this.trainingFilter.overdueAfter), // true if training was overdue
          });
        });

        if (!openTraining) {
          // there is no open training (but the user did at least one)
          if (closedSince >= Number(this.trainingFilter.retrainingAfter)) {
            // unfortunately it was too long ago
            this.analysis[itemWithData.itemId].users[
              user
            ].thereShouldBeATraining = true;
          }
        }
      }
    }

    return true; // process is a process which needs training
  }

  private drawTable() {
    let that = this;

    ml.UI.BlockingProgress.SetProgress(
      0,
      this.PROGRESS_PROC + this.PROGRESS_NOTIFICATION + this.PROGRESS_MATH,
      'Rendering Table',
    );

    this.data.html('');

    // prepare table
    this.createMainContainer(this.data);

    // ************************************
    // add filters
    // ************************************

    this.addFilters();

    // ************************************
    // apply filters / determine initial visibility
    // ************************************

    this.lastHiding = this.determineVisibility();

    // ************************************
    // add users in top row
    // ************************************

    $.each(this.users, (uidx, user) => {
      let th = $(
        "<th class='rotate filterProject' style='padding: 0 0 0 1px;'>",
      )
        .html(
          "<div><span title='" +
            globalMatrix.ItemConfig.getFullName(user) +
            "'>" +
            user +
            '</span></div>',
        )
        .data('user', user)
        .appendTo(this.headerRow);
      if (this.lastHiding.columns.includes(uidx)) {
        th.hide();
      }
    });

    // ************************************
    // render details of analysis
    // ************************************

    this.leftBody.hide();
    this.accessBody.hide();
    this.drawTableRows();

    // ************************************
    // add a menu for each cell on click
    // ************************************

    this.initCellMenu((cell, cmd) => {
      this.cellMenuAction(cell, cmd);
    });

    // show full item titles
    this.data.highlightReferences();

    // show table and enable scrolling
    this.leftBody.show();
    this.accessBody.show();
    this.initTableScrolling(this.data, 0);

    // ************************************
    // show details for each cell on hover
    // ************************************

    this.initTooltipBox((cell) => {
      if (cell.data('verbose')) {
        return cell.data('verbose');
      }
      return '';
    });

    // ************************************
    // add a note about items which don't need training
    // ************************************

    if (this.itemsWithoutNeedForTraining.length) {
      let note = $("<div class='hideCopy' style='margin-top:24px;'>").appendTo(
        this.panel,
      );
      $(
        "<div style='font-style: italic;font-size: smaller;'>Notes:</div>",
      ).appendTo(note);
      let li = $('<li>').appendTo($('<ul>').appendTo(note));
      $(
        "<button class='btn btn-link' style'outline: none !important;'>There are items without required training</button>",
      )
        .appendTo(li)
        .click(() => {
          let dlg = $('<div>').appendTo($('body'));
          let ui = $("<div style='width:100%;height:100%'>");

          $("<ul class='hideCopy'>")
            .html(
              '<li>' +
                this.itemsWithoutNeedForTraining.join('!</li><li>') +
                '!</li>',
            )
            .appendTo(ui)
            .highlightReferences();

          ml.UI.showDialog(
            dlg,
            'Items without required training',
            ui,
            -730,
            -440,
            [
              {
                text: 'Ok',
                class: 'btnDoIt',
                click: () => {
                  dlg.dialog('close');
                },
              },
            ],
            UIToolsConstants.Scroll.Auto,
            true,
            true,
            () => {
              dlg.remove();
            },
            () => {},
            () => {},
          );
        });
    }

    ml.UI.BlockingProgress.SetProgress(0, 100);
  }

  // render the rows without blocking/ui

  private drawTableRows() {
    let that = this;

    let timer = new Date();

    let processListHTML = '';
    let processUserHTML = '';

    for (let row = 0; row < this.itemsWithNeedForTraining.length; row++) {
      let hidingRow = this.lastHiding.rows.includes(row) ? 'display:none' : '';
      let process = this.itemsWithNeedForTraining[row];
      let processInfo = this.analysis[process];

      // get the id and title of the item
      let itemInfo = process + ' ' + processInfo.title + ' ';
      if (processInfo.labels) {
        $.each(this.labelsCatsWithTraining, (lIdx, label) => {
          if (processInfo.labels.indexOf('(' + label.label + ')') != -1) {
            itemInfo += label.displayName + ' ';
          }
        });
      }

      processListHTML += `<tr data-item="${itemInfo.toLowerCase()}" data-itemId="${process}" title="${itemInfo}" style="${hidingRow}"><td class="ua_user" style="white-space: nowrap; max-width:60vw;">${process}!</td></tr>`;
      // popover({ content: itemInfo,  trigger: 'hover', placement: "bottom", container: "body",delay:400, html:true });

      // create fields for all the users
      processUserHTML += `<tr style="${hidingRow}">`;
      for (let userIdx = 0; userIdx < this.users.length; userIdx++) {
        let user = this.users[userIdx];
        let hidingCol =
          this.lastHiding.rows.includes(row) ||
          this.lastHiding.columns.includes(userIdx)
            ? 'display:none'
            : '';
        let status = this.getTrainingStatusUserProcess(user, process);

        processUserHTML += `<td style="${hidingCol}" class='ua_level ${status.classes}' data-user="${user}" data-item="${process}" data-verbose="${status.verbose}">${status.text}</td>`;
      }
      processUserHTML += '</tr>';
    }
    console.log(
      'tablerows-build' +
        ': ' +
        (new Date().getTime() - timer.getTime()) +
        'ms',
    );
    this.leftBody.append(processListHTML);
    this.accessBody.append(processUserHTML);
    console.log(
      'tablerows-render' +
        ': ' +
        (new Date().getTime() - timer.getTime()) +
        'ms',
    );
  }

  // a generic function which runs a callback count times,  giving control to the UI a few times to avoid blocking
  async fastAsyncFor(
    timing: string,
    count: number,
    breath: number,
    callback: any,
  ) {
    let timer = new Date();
    for (let idx = 0; idx < count; idx++) {
      if (idx % breath == 0) {
        const promise = new Promise<void>((resolve, _reject) => {
          setTimeout(() => {
            callback(idx);
            resolve();
          }, 0);
        });
        await promise;
      } else {
        callback(idx);
      }
    }
    console.log(
      timing + ': ' + (new Date().getTime() - timer.getTime()) + 'ms',
    );
  }

  async asyncRun(callback: () => void) {
    const promise = new Promise<void>((resolve, _reject) => {
      setTimeout(() => {
        callback();
        resolve();
      }, 30); // to allow progress bar to be displayed
    });
    await promise;
  }

  // call through menu of cell
  private updateTrainingStatus(td: JQuery, user: string, process: string) {
    // clean the cell
    td.removeClass('noTraining')
      .removeClass('needTraining')
      .removeClass('firstTrainingRequired')
      .removeClass('reTrainingRequired')
      .removeClass('openTraining')
      .removeClass('overdue')
      .removeClass('due')
      .removeClass('hadTraining')
      .data('verbose', '');

    let status = this.getTrainingStatusUserProcess(user, process);

    td.html(status.text)
      .addClass(status.classes)
      .data('verbose', status.verbose);
  }

  private getTrainingStatusUserProcess(
    user: string,
    process: string,
  ): ITrainingCellStatus {
    let status: ITrainingCellStatus = {
      verbose: '',
      text: '',
      classes: '',
    };

    let analProcess = this.analysis[process];
    if (!analProcess.hasTraining || !analProcess.users[user]) {
      // user does not need training
      status.text = '&nbsp;';
      status.classes = ' noTraining';
      return status;
    }

    let analUser = analProcess.users[user];

    if (analUser.thereShouldBeATraining) {
      status.classes = ' needTraining';
      status.text = '()';
      if (analUser.trainingsDone.length == 0) {
        status.classes += ' firstTrainingRequired';
        status.verbose = 'Need to schedule a first training.';
      } else {
        status.classes += ' reTrainingRequired';
        status.verbose = 'Need to schedule a renewal training.';
      }
      return status;
    }

    if (analUser.thereIsATraining) {
      status.classes += ' openTraining';
      // there is an open training, depending on the setting this might be overdue
      if (analUser.theTrainingIsOverdue) {
        status.text = '!!';
        status.classes += ' overdue';
        status.verbose =
          'Overdue training. Due since ' +
          analUser.theTrainingExistsSinceDays +
          ' days.';
      } else {
        status.text = '!';
        status.classes += ' due';
        status.verbose =
          'Training open training since ' +
          analUser.theTrainingExistsSinceDays +
          ' days.';
      }
      return status;
    }

    // training was done
    status.text = '&#10004';
    status.classes += 'hadTraining';
    status.verbose =
      'Had training on ' +
      ml.UI.DateTime.renderCustomerHumanDate(analUser.lastTrainingDate, true) +
      '.';
    return status;
  }

  // figure which rows and columns should be hidden -> this depends on filters and the training status of each cell
  private determineVisibility(): IHiding {
    let hiding: IHiding = {
      rows: [],
      columns: [],
    };

    let userCount = this.users.length;
    let itemCount = this.itemsWithNeedForTraining.length;
    // create one big matrix for each process/user combo
    let hidden: boolean[][] = [];
    for (let processIdx = 0; processIdx < itemCount; processIdx++) {
      hidden[processIdx] = [];
    }

    // set all cells/columns to hidden if user is hidden
    if (this.trainingFilter.user && this.trainingFilter.user.length) {
      for (let userIdx = 0; userIdx < userCount; userIdx++) {
        let user = this.users[userIdx];
        if (this.trainingFilter.user.indexOf(user) == -1) {
          hiding.columns.push(userIdx);
          for (let row = 0; row < itemCount; row++) {
            //@ts-ignore
            hidden[row][user] = true;
          }
        }
      }
    }

    // now go through processes
    for (let processIdx = 0; processIdx < itemCount; processIdx++) {
      let process = this.itemsWithNeedForTraining[processIdx];

      // hide the row if there's a non matching filter for processes
      let processInfo = this.analysis[process];
      let rowIsHidden = false;
      if (this.trainingFilter.itemInfo) {
        // not all rows should be shown
        if (process.indexOf(this.trainingFilter.itemInfo) == -1) {
          // the filter does not match this process' item id
          if (processInfo.title.indexOf(this.trainingFilter.itemInfo) == -1) {
            let labels = '';
            // the filter does not match this process' title
            if (processInfo.labels) {
              $.each(this.labelsCatsWithTraining, (lIdx, label) => {
                if (processInfo.labels.indexOf('(' + label.label + ')') != -1) {
                  labels += label.displayName + ' ';
                }
              });
            }
            if (labels.indexOf(this.trainingFilter.itemInfo) == -1) {
              // the filter does not match this process' labels / nor the id matches, nor the name
              hiding.rows.push(processIdx);
              rowIsHidden = true;
            }
          }
        }
      }

      // now go through all columns
      let atLeastOneVisible = false;
      for (let userIdx = 0; userIdx < userCount; userIdx++) {
        if (rowIsHidden) {
          // hide all the cells
          hidden[processIdx][userIdx] = true;
        } else {
          let user = this.users[userIdx];

          hidden[processIdx][userIdx] = hiding.columns.includes(userIdx);
          if (!hidden[processIdx][userIdx]) {
            // for now the cell is not hidden

            // get training status of this user
            let trainingStatus: ETrainingStatus = ETrainingStatus.notNeeded;
            let analProcess = this.analysis[process];
            if (!analProcess.hasTraining || !analProcess.users[user]) {
              // user does not need training
              trainingStatus = ETrainingStatus.notNeeded;
            } else {
              let analUser = analProcess.users[user];

              if (analUser.thereShouldBeATraining) {
                trainingStatus = ETrainingStatus.needed;
              } else if (analUser.thereIsATraining) {
                if (analUser.theTrainingIsOverdue) {
                  trainingStatus = ETrainingStatus.overdue;
                } else {
                  trainingStatus = ETrainingStatus.due;
                }
              } else {
                trainingStatus = ETrainingStatus.done;
              }
            }
            // now decide whether to show the cell
            let keepOverdue =
              !this.trainingFilter.overdue &&
              trainingStatus == ETrainingStatus.overdue;
            let keepDue =
              !this.trainingFilter.due && trainingStatus == ETrainingStatus.due;
            let keepTraining =
              !this.trainingFilter.new &&
              trainingStatus == ETrainingStatus.needed;
            let keepOk =
              !this.trainingFilter.ok && trainingStatus == ETrainingStatus.done;
            let keepNone =
              !this.trainingFilter.none &&
              trainingStatus == ETrainingStatus.notNeeded;
            if (
              !(keepOverdue || keepDue || keepTraining || keepOk || keepNone)
            ) {
              hidden[processIdx][userIdx] = true;
            }
          }
          if (!hidden[processIdx][userIdx]) {
            atLeastOneVisible = true;
          }
        }
      }

      // if all cells are hidden we can actually hide the row!
      if (!atLeastOneVisible && !rowIsHidden) {
        hiding.rows.push(processIdx);
      }
    }
    // now go through all users and hide these where were is nothing to show
    for (let userIdx = 0; userIdx < userCount; userIdx++) {
      let atLeastOneVisible = false;
      for (
        let processIdx = 0;
        !atLeastOneVisible && processIdx < itemCount;
        processIdx++
      ) {
        if (!hidden[processIdx][userIdx]) {
          atLeastOneVisible = true;
        }
      }
      if (!atLeastOneVisible && !hiding.columns.includes(userIdx)) {
        hiding.columns.push(userIdx);
      }
    }

    return hiding;
  }

  private async updateTrainings() {
    let that = this;

    let oldAnalysis = this.analysis;
    // do a new analysis
    await this.analyzeProcesses();
    // repaint the cells if needed
    let trs = $('tr', this.accessBody);
    for (let rowIdx = 0; rowIdx < trs.length; rowIdx++) {
      let tds = $('td', trs[rowIdx]);
      let procId = this.itemsWithNeedForTraining[rowIdx];
      for (let colIdx = 0; colIdx < trs.length; colIdx++) {
        let user = this.users[colIdx];
        let old = oldAnalysis[procId].users[user];
        let now = this.analysis[procId].users[user];
        if (!old && !now) {
        } else if (
          (!old && now) ||
          (old && !now) ||
          old.theTrainingIsOverdue != now.theTrainingIsOverdue ||
          old.thereShouldBeATraining != now.thereShouldBeATraining ||
          old.trainingsDone != now.trainingsDone ||
          old.thereIsATraining != now.thereIsATraining
        ) {
          this.updateTrainingStatus($(tds[colIdx]), user, procId);
        }
      }
    }
  }

  // updates the table - this is called if for example a filter changed
  private updateVisibility() {
    let that = this;

    let nextHiding = this.determineVisibility();

    // create todo lists of what should be toggled
    let hideRows = nextHiding.rows.filter(
      (x) => this.lastHiding.rows.indexOf(x) == -1,
    ); // everything which is hidden now but wasn't before
    let showRows = this.lastHiding.rows.filter(
      (x) => nextHiding.rows.indexOf(x) == -1,
    ); // vv
    let hideColumns = nextHiding.columns.filter(
      (x) => this.lastHiding.columns.indexOf(x) == -1,
    ); // everything which is hidden now but wasn't before
    let showColumns = this.lastHiding.columns.filter(
      (x) => nextHiding.columns.indexOf(x) == -1,
    ); // vv

    // remember hiding
    this.lastHiding = nextHiding;

    // got through all three tables and toggle
    let leftRows = $('tr', this.leftBody);
    let rightRows = $('tr', this.accessBody);
    for (let row = 0; row < leftRows.length; row++) {
      // toggle row visibility
      if (hideRows.indexOf(row) != -1) {
        $(leftRows[row]).hide();
        $(rightRows[row]).hide();
      } else if (showRows.indexOf(row) != -1) {
        $(leftRows[row]).show();
        $(rightRows[row]).show();
      }
      // toggle column visibility in each row
      let tds = $('td', rightRows[row]);
      for (let col = 0; col < tds.length; col++) {
        // toggle row visibility
        if (hideColumns.indexOf(col) != -1) {
          $(tds[col]).hide();
        } else if (showColumns.indexOf(col) != -1) {
          $(tds[col]).show();
        } else {
          let isHidden = $(tds[col]).css('display') == 'none';
          let shouldBeHidden = nextHiding.columns.indexOf(col) != -1;
          if (isHidden != shouldBeHidden) {
            if (shouldBeHidden) {
              $(tds[col]).hide();
            } else {
              $(tds[col]).show();
            }
          }
        }
      }
    }

    // toggle headers of table
    let tds = $('th', this.headerRow);
    for (let col = 0; col < tds.length; col++) {
      // toggle row visibility
      if (hideColumns.indexOf(col) != -1) {
        $(tds[col]).hide();
      }
      if (showColumns.indexOf(col) != -1) {
        $(tds[col]).show();
      }
    }

    this.initTableScrolling(this.data, 0);
  }

  // ************************
  // action wizards
  // ************************

  // creates a training report
  private createReportWizard() {
    let that = this;

    let dlg = $('<div>').appendTo('body');
    let contentStep = $('<div>');

    // dummy for cursor
    $("<input type='text' style='position: absolute;top: -10000px;'>").appendTo(
      contentStep,
    );

    let dateOptions: IDropdownOption[] = [
      { id: '7', label: '1 week' },
      { id: '14', label: '2 weeks' },
      { id: '21', label: '3 weeks' },
      { id: '30', label: '1 month' },
      { id: '61', label: '2 months' },
      { id: '91', label: '3 months' },
      { id: '182', label: '6 months' },
      { id: '365', label: '1 year' },
      { id: '730', label: '2 years' },
      { id: '1095', label: '3 years' },
    ];

    // currently visible procs and users
    let selectedUsers = $('th:visible', this.headerRow)
      .toArray()
      .map((x) => $(x).data('user'));
    let selectedProcs = $('tr:visible', this.leftBody)
      .toArray()
      .map((x) => $(x).data('itemid'));

    // all cats with trainings
    let catsWithTraining = this.getCatsWithTrainings();

    // params needed for report
    let reportParams = {
      period: globalMatrix.projectStorage.getItemDefault(
        'trainingReportPeriod',
        '365',
      ),
      usersRaw: selectedUsers,
      user: ml.UI.SelectUserOrGroup.getUsersInSelection(selectedUsers),
      processes: JSON.stringify(
        selectedProcs.map((p) => {
          return { to: p };
        }),
      ),
    };

    // ask for period (default to last selected / 1Y)
    ml.UI.addDropdownToValue(
      contentStep,
      'Show report for last',
      reportParams,
      'period',
      dateOptions,
      false,
      false,
      () => {
        globalMatrix.projectStorage.setItem(
          'trainingReportPeriod',
          reportParams.period,
        );
        enableNext();
      },
    );

    // ask for which users
    ml.UI.SelectUserOrGroup.showMultiUserSelect(
      contentStep,
      'Select Users',
      reportParams.usersRaw,
      'Select User',
      '',
      '',
      true,
      true,
      (selection: string[]) => {
        reportParams.user =
          ml.UI.SelectUserOrGroup.getUsersInSelection(selection);
        enableNext();
      },
    );

    // ask for processes
    let procs = $('<div>').appendTo(contentStep);
    procs.itemSelection({
      canEdit: true,
      help: 'Processes',
      fieldValue: reportParams.processes,
      preciseSelection: true,
      valueChanged: async () => {
        reportParams.processes = await procs.getController().getValueAsync();
        enableNext();
      },
      parameter: {
        prefix: 'Select processes to include',
        buttonName: 'Select',
        showOnly: catsWithTraining,
      },
    });

    ml.UI.showDialog(
      dlg,
      'Create Training Report',
      contentStep,
      730,
      440,
      [
        {
          text: 'Next',
          class: 'btnDoIt',
          click: () => {
            if (step == 1) {
              step = 2;
              contentStep.html('');
              this.renderReport(
                contentStep,
                reportParams.period,
                reportParams.user,
                JSON.parse(reportParams.processes).map((p: IReference) => p.to),
              );
            } else {
              // replace links + title with smart links
              $.each($('.macro', contentStep), (i, m) => {
                let item = $('.highLink', m).text();
                if (item) $(m).replaceWith(`<span>${item}!</span>`);
              });

              ml.UI.doCopy(contentStep, () => {});
              dlg.dialog('close');
            }
          },
        },
        {
          text: 'Cancel',
          class: 'btnCancelIt',
          click: () => {
            dlg.dialog('close');
          },
        },
      ],
      UIToolsConstants.Scroll.Vertical,
      true,
      true,
      () => {
        // close
        dlg.remove();
      },
      () => {
        // open
      },
      () => {
        // resize
      },
    );

    let step = 1;

    function enableNext() {
      let enabled = false;
      if (step == 1) {
        enabled =
          reportParams.period != '' &&
          reportParams.processes != '' &&
          reportParams.user.length != 0;
      }
      ml.UI.setEnabled(dlg.parent().find('.btnDoIt'), enabled);
    }

    enableNext();
  }

  private renderReport(
    report: JQuery,
    period: string,
    users: string[],
    procSelection: string[],
  ) {
    report.append(`<p class="h1">Analysis Trainings</p>`);
    report.append(`<p class="h2">Summary Trainings</p>`);

    // get procs from user selection
    let selectedProcs: string[] = [];
    for (let itemOrFolder of procSelection) {
      let items = app.getChildrenIdsRec(itemOrFolder);
      selectedProcs = selectedProcs.concat(items);
    }
    // *******************************
    // make basic stats
    // *******************************

    let procs = Object.keys(this.analysis).filter(
      (p) => selectedProcs.indexOf(p) != -1,
    );

    if (!procs.length) {
      report.append(
        `<p>There are no processes selected which need training</p>`,
      );
      return;
    }
    if (!users.length) {
      report.append(`<p>There are no users selected which need training</p>`);
      return;
    }

    let totalTrainingsDefined = 0; // #procs X #users(proc)
    let totalTrainingsOpen = 0;
    let totalTrainingsOverdue = 0;
    let totalTrainingsDone = 0;
    let totalTrainingsDoneInTime = 0;

    let userTrainingDefined: IStringNumberMap = {};
    let userTrainingOpen: IStringNumberMap = {};
    let userTrainingOverdue: IStringNumberMap = {};
    let userHasDoneTrainingsTotal: IStringNumberMap = {};
    let userHasDoneTrainingsTotalInTime: IStringNumberMap = {};
    for (let user of users) {
      userTrainingDefined[user] = 0;
      userTrainingOpen[user] = 0;
      userTrainingOverdue[user] = 0;
      userHasDoneTrainingsTotal[user] = 0;
      userHasDoneTrainingsTotalInTime[user] = 0;
    }

    for (let proc of procs) {
      for (let user of users) {
        if (this.analysis[proc].users[user]) {
          totalTrainingsDefined++;
          userTrainingDefined[user]++;
          if (this.analysis[proc].users[user].thereIsATraining) {
            totalTrainingsOpen++;
            userTrainingOpen[user]++;
          }
          if (this.analysis[proc].users[user].theTrainingIsOverdue) {
            totalTrainingsOverdue++;
            userTrainingOverdue[user]++;
          }
          totalTrainingsDone +=
            this.analysis[proc].users[user].trainingsDone.length;
          totalTrainingsDoneInTime += this.analysis[proc].users[
            user
          ].trainingsDone.filter((td) => !td.trainingOverdue).length;

          userHasDoneTrainingsTotal[user] +=
            this.analysis[proc].users[user].trainingsDone.length;
          userHasDoneTrainingsTotalInTime[user] += this.analysis[proc].users[
            user
          ].trainingsDone.filter((td) => !td.trainingOverdue).length;
        }
      }
    }

    // *******************************
    // * 120 days covered
    // * 12 procs needs training
    // * 15 users included
    // * 166 trainings covered
    // *******************************

    report.append(`<p>The report covers the last <b>${period}</b> days</p>`);

    let ul = $('<ul>').appendTo(report);
    ul.append(`<li><b>${procs.length}</b> processes covered</li>`);
    ul.append(`<li><b>${users.length}</b> users covered</li>`);
    ul.append(
      `<li><b>${totalTrainingsDefined}</b> trainings are defined for these processes and users</li>`,
    );

    report.append(
      `<p>From the defined <b>${totalTrainingsDefined}</b> trainings currently  <b>${totalTrainingsOpen}</b> still need to be done. Of these <b>${totalTrainingsOverdue}</b> are overdue!</p>`,
    );

    report.append(`<p class="h2">Current Status</p>`);

    let g1 = $("<div style='width:600px'>").appendTo(report);
    this.addDonut(g1, 'Trainings Done vs Open', [
      {
        text: 'Training Done',
        count: totalTrainingsDefined - totalTrainingsOpen,
      },
      {
        text: 'Training Open',
        count: totalTrainingsOpen - totalTrainingsOverdue,
      },
      { text: 'Training Overdue', count: totalTrainingsOverdue },
    ]);

    report.append(`<p class="h2">Statistics Done Trainings</p>`);

    report.append(
      `<p>From the <b>${totalTrainingsDone}</b> completed, <b>${totalTrainingsDoneInTime}</b> have been completed in time </p>`,
    );
    report.append(`<p><b>User motivation</b></p>`);

    let usersAllGood = 0;
    let users90Good = 0;
    let users80Good = 0;
    let users70Good = 0;
    let usersNoGood = 0;
    for (let user of users) {
      if (userTrainingDefined[user]) {
        let overduePercent =
          userTrainingOverdue[user] / userTrainingDefined[user];
        if (overduePercent == 0) usersAllGood++;
        else if (overduePercent < 0.1) users90Good++;
        else if (overduePercent < 0.2) users80Good++;
        else if (overduePercent < 0.3) users70Good++;
        else usersNoGood++;
      }
    }
    let g2 = $("<div style='width:400px'>").appendTo(report);
    this.addDonut(g2, 'User behavior', [
      { text: '#Users completed all in time', count: usersAllGood },
      { text: '> 90% trainings completed in time', count: users90Good },
      { text: '> 80% trainings completed in time', count: users80Good },
      { text: '> 70% trainings completed in time', count: users70Good },
      { text: '<= 70% trainings completed in time>', count: usersNoGood },
    ]);
    report.append(`<p class="h2">Per User Summary</p>`);
    report.append(
      `<p style="font-size: smaller;font-style: italic;">Note: higher percentages are better!</p>`,
    );

    let table = $(`<table class="table table-bordered">
        <thead><tr>
            <th rowspan="2">User</td>
            <th colspan="2">Processes with training</th>
            <th colspan="2">Trainings to do</th>
            <th colspan="2">Total trainings done</th></tr><tr>
            <th>count</th>
            <th>done</th>
            <th>open</th>
            <th>in time</th>
            <th>done</th>
            <th>done timely</th></tr></thead>
        </table>`).appendTo(report);
    let tbody = $('<tbody>').appendTo(table);

    for (let user of users) {
      let percentDone = '';
      if (userTrainingDefined[user]) {
        percentDone = ` (${Math.floor((100 * (userTrainingDefined[user] - userTrainingOpen[user])) / userTrainingDefined[user])}%)`;
      }
      let percentOverdue = '';
      if (userTrainingOpen[user]) {
        percentOverdue = ` (${Math.floor((100 * (userTrainingOpen[user] - userTrainingOverdue[user])) / userTrainingOpen[user])}%)`;
      }
      let percentInTime = '';
      if (userHasDoneTrainingsTotal[user]) {
        percentInTime = ` (${Math.floor((100 * userHasDoneTrainingsTotalInTime[user]) / userHasDoneTrainingsTotal[user])}%)`;
      }
      $(`<tr><td>${globalMatrix.ItemConfig.getFullName(user)}</td>
                <td>${userTrainingDefined[user]}</td>
                <td>${userTrainingDefined[user] - userTrainingOpen[user]}${percentDone}</td>
                <td>${userTrainingOpen[user]}</td>
                <td>${userTrainingOpen[user] - userTrainingOverdue[user]}${percentOverdue}</td>
                <td>${userHasDoneTrainingsTotal[user]}</td>
                <td>${userHasDoneTrainingsTotalInTime[user]}${percentInTime}</td>
            </tr>`).appendTo(tbody);
    }
    report.append(`<p class="h2">Trainings Done Per User</p>`);
    let today = new Date();
    const oneDay = 24 * 60 * 60 * 1000;
    for (let user of users) {
      report.append(
        `<p><b>${globalMatrix.ItemConfig.getFullName(user)}</b></p>`,
      );

      $(`<p>Trainings Done in the last <b>${period}</b> days</p>`).appendTo(
        report,
      );
      let doneCount = 0;
      let done = $('<ul>').appendTo(report);
      let beforeHeading = $(`<p>Trainings done earlier</p>`).appendTo(report);
      let beforeCount = 0;
      let before = $('<ul>').appendTo(report);
      $(`<p>Upcoming trainings</p>`).appendTo(report);
      let openCount = 0;
      let open = $('<ul>').appendTo(report);

      for (let proc of procs) {
        if (this.analysis[proc].users[user]) {
          let doneInPeriod = 0;
          for (let done of this.analysis[proc].users[user].trainingsDone) {
            let doneDate = new Date(done.trainingDone);
            let diffDays = Math.round(
              (today.getTime() - doneDate.getTime()) / oneDay,
            );
            if (diffDays <= Number(period)) {
              doneInPeriod++;
            }
          }
          if (doneInPeriod) {
            doneCount++;
            let count = doneInPeriod == 1 ? '' : `(done ${doneInPeriod} times)`;
            let lastTraining = `(last training: ${ml.UI.DateTime.renderHumanDate(this.analysis[proc].users[user].lastTrainingDate, true)})`;
            $(
              `<li>${proc}! <span style="font-size: smaller;font-style: italic;">${count} ${lastTraining}</span></li>`,
            ).appendTo(done);
          } else {
            if (this.analysis[proc].users[user].trainingsDone.length > 0) {
              beforeCount++;
              let lastTraining = `(last training: ${ml.UI.DateTime.renderHumanDate(this.analysis[proc].users[user].lastTrainingDate, true)})`;
              $(
                `<li>${proc}! <span style="font-size: smaller;font-style: italic;">${lastTraining}</span></li>`,
              ).appendTo(before);
            }
          }
          if (this.analysis[proc].users[user].thereIsATraining) {
            openCount++;
            $(`<li>${proc}!</li>`).appendTo(open);
          }
        }
      }

      if (doneCount == 0) {
        $(`<li>no trainings done in this period</li>`).appendTo(done);
      }
      if (beforeCount == 0) {
        beforeHeading.remove();
      }
      if (openCount == 0) {
        $(`<li>no open trainings at this point</li>`).appendTo(done);
      }
    }

    report.highlightReferences();
    return report;
  }

  private onboardUserWizard() {
    let that = this;

    let dlg = $('<div>').appendTo('body');
    let contentStep = $('<div>');

    // filled by wizard
    let onboardedUser = ''; // filled by wizard step 1
    let onboardedUsersGroups: number[] = []; // filled by wizard step 2
    let onboardedUsersTrainings: string[] = []; // filled by wizard step 3

    $(`<p>Use this wizard to assign a user to user roles and create trainings accordingly. </p>
            <ul><li>Step 1: Select the new team member</li>
            <li>Step 2: Add or remove the user to user groups needing training</li>
            <li>Step 3: Acknowledge the creation of trainings for the processes for this user / user groups</li>
            <li>Step 4: Create trainings for the user</li>
            </ul>`).appendTo(contentStep);

    ml.UI.showDialog(
      dlg,
      'Onboarding',
      contentStep,
      730,
      440,
      [
        {
          text: 'Next',
          class: 'btnDoIt',
          click: async () => {
            if (step == 0) {
              /*********************** STEP 1 - select user ********************** */
              step = 1;
              contentStep.html(`<p><b>Step ${step}</b></p>`);

              $(
                '<span class="baseControlHelp">' + 'Select User ' + '</span>',
              ).appendTo(contentStep);

              let ctrl = $("<div class='baseControl'>").appendTo(contentStep);
              let input = $("<div class='form-control'>").appendTo(ctrl);

              // ask for which users
              ml.UI.SelectUserOrGroup.showSingleSelect(
                input,
                true,
                false,
                (selected) => {
                  onboardedUser = selected;
                  enableNext();
                },
              );
            } else if (step == 1) {
              /*********************** STEP 2 - select groups ********************** */
              step = 2;
              contentStep.html(`<p><b>Step ${step}</b></p>`);

              $(
                '<span class="baseControlHelp">' +
                  'User is in the following groups ' +
                  (matrixSession.isAdmin()
                    ? '(check to add to more)'
                    : '(ask an administrator to modify these)') +
                  '</span>',
              ).appendTo(contentStep);
              let ctrl = $("<div class='baseControl'>").appendTo(contentStep);
              for (let group of this.userGroups) {
                let isMember =
                  group.membership.map((m) => m.login).indexOf(onboardedUser) !=
                  -1;
                if (isMember) {
                  onboardedUsersGroups.push(group.groupId);
                }
                let cb = $(
                  `<div class="checkbox" ><label><input type="checkbox" ${isMember ? 'checked' : ''} ${matrixSession.isAdmin() ? '' : 'disabled'}>${group.groupName}</label></div></div>`,
                ).appendTo(ctrl);

                $("input[type='checkbox']", cb).change(
                  (event: JQueryMouseEventObject) => {
                    let checked = $(event.delegateTarget).is(':checked');

                    if (checked) {
                      restConnection
                        .putServer(
                          'group/' + group.groupId + '/user/' + onboardedUser,
                          { reason: 'qms training dashboard' },
                        )
                        .done(() => {
                          onboardedUsersGroups.push(group.groupId);
                          group.membership.push(<any>{ login: onboardedUser });
                          globalMatrix.ItemConfig.addGroupMember(
                            group.groupId,
                            onboardedUser,
                          );
                        });
                    } else {
                      restConnection
                        .deleteServerAsync(
                          'group/' + group.groupId + '/user/' + onboardedUser,
                          { reason: 'qms training dashboard' },
                        )
                        .done(() => {
                          onboardedUsersGroups = onboardedUsersGroups.filter(
                            (g) => g != group.groupId,
                          );
                          group.membership = group.membership.filter(
                            (m) => m.login != onboardedUser,
                          );
                          globalMatrix.ItemConfig.removeGroupMember(
                            group.groupId,
                            onboardedUser,
                          );
                        });
                    }
                  },
                );
              }
            } else if (step == 2) {
              /*********************** STEP 3 - select trainings ********************** */
              step = 3;
              contentStep.html(`<p><b>Step ${step}</b></p>`);

              // user might have changed groups
              await this.analyzeProcesses();

              $(
                '<span class="baseControlHelp">Suggested trainings based on the group membership are checked below:</span>',
              ).appendTo(contentStep);
              let allItems = Object.keys(this.analysis);

              let itemsWithTrainings = allItems.filter(
                (item) => this.analysis[item].hasTraining,
              );

              let added = 0;

              for (let itemWithTraining of itemsWithTrainings) {
                let needsTraining =
                  this.analysis[itemWithTraining].users[onboardedUser] && // the user needs training in general
                  !this.analysis[itemWithTraining].users[onboardedUser]
                    .thereIsATraining && // nothing is currently planned
                  this.analysis[itemWithTraining].users[onboardedUser]
                    .trainingsDone.length == 0; // no training was done

                let reason = '';
                if (needsTraining) {
                  onboardedUsersTrainings.push(itemWithTraining);
                } else if (
                  !this.analysis[itemWithTraining].users[onboardedUser]
                ) {
                  // process has nothing to do with user. don't even show it
                  continue;
                } else if (
                  this.analysis[itemWithTraining].users[onboardedUser]
                    .thereIsATraining
                ) {
                  // there: is already a training... don't even show it
                  continue;
                } else if (
                  this.analysis[itemWithTraining].users[onboardedUser]
                    .trainingsDone.length
                ) {
                  reason = '(the user did already a training)';
                }

                added++;
                let cb = $(
                  `<div class="checkbox" ><label><input type="checkbox" ${needsTraining ? 'checked' : ''}>${itemWithTraining}! <span style="font-weight:600">${reason}</span></label></div></div>`,
                ).appendTo(contentStep);

                $("input[type='checkbox']", cb).change(
                  (event: JQueryMouseEventObject) => {
                    let checked = $(event.delegateTarget).is(':checked');

                    if (checked) {
                      onboardedUsersTrainings.push(itemWithTraining);
                    } else {
                      onboardedUsersTrainings = onboardedUsersTrainings.filter(
                        (item) => item != itemWithTraining,
                      );
                    }
                  },
                );
              }
              if (added) {
                contentStep.highlightReferences();
              } else {
                $(
                  '<div>The user is not member of a group which requires (additional) trainings. Add the user to some (more) user groups.</div>',
                ).appendTo(contentStep);
              }
            } else if (step == 3) {
              step = 4;
              contentStep.html(`<p><b>Step ${step}</b></p>`);

              if (onboardedUsersTrainings.length) {
                if (onboardedUsersTrainings.length > 2) {
                  ml.UI.Progress.Init('Creating Trainings');
                }

                that
                  .createTrainingsRec(
                    onboardedUsersTrainings,
                    //@ts-ignore
                    null,
                    onboardedUser,
                  )
                  .then(async () => {
                    ml.UI.showSuccess(
                      'Done creating trainings. Updating view...',
                      1000,
                    );
                    await this.getAndAnalyzeData();
                    await this.updateTrainings();
                    this.updateVisibility();
                  });
              }

              dlg.dialog('close');
            }
          },
        },
        {
          text: 'Cancel',
          class: 'btnCancelIt',
          click: () => {
            dlg.dialog('close');
          },
        },
      ],
      UIToolsConstants.Scroll.Vertical,
      true,
      true,
      () => {
        // close
        dlg.remove();
      },
      () => {
        // open
      },
      () => {
        // resize
      },
    );

    let step = 0;

    function enableNext() {
      let enabled = false;
      if (step == 0) {
        enabled = true;
      } else if (step == 1) {
        enabled = onboardedUser != '';
      }
      ml.UI.setEnabled(dlg.parent().find('.btnDoIt'), enabled);
    }

    enableNext();
  }

  private createTrainingWizard() {
    let that = this;

    let dlg = $('<div>').appendTo('body');
    let contentStep = $('<div>');

    // filled by wizard
    let trainingJobs: IStringStringArrayMap = {};

    $(`<p>Use this function to create trainings for the selected users and processes. </p>
        <ul><li>Step 1: Decide for which users and processes and after which time a user needs to redo a training</li>
        <li>Step 2: Acknowledge the trainings to be created per each user</li>
        <li>Step 3: Create the trainings</li>
        </ul>`).appendTo(contentStep);

    let dateOptions: IDropdownOption[] = [
      { id: '30', label: '1 month ago' },
      { id: '61', label: '2 months ago' },
      { id: '91', label: '3 months ago' },
      { id: '182', label: '6 months ago' },
      { id: '365', label: '1 year ago' },
      { id: '730', label: '2 years ago' },
      { id: '1095', label: '3 years ago' },
    ];

    // currently visible procs and users
    let selectedUsers = $('th:visible', this.headerRow)
      .toArray()
      .map((x) => $(x).data('user'));
    let selectedProcs = $('tr:visible', this.leftBody)
      .toArray()
      .map((x) => $(x).data('itemid'));

    // all cats with trainings
    let catsWithTraining = this.getCatsWithTrainings();

    // params needed
    let wizardParams = {
      period: globalMatrix.projectStorage.getItemDefault(
        'trainingPeriodRedo',
        '365',
      ),
      usersRaw: selectedUsers,
      user: ml.UI.SelectUserOrGroup.getUsersInSelection(selectedUsers),
      processes: JSON.stringify(
        selectedProcs.map((p) => {
          return { to: p };
        }),
      ),
    };

    ml.UI.showDialog(
      dlg,
      'Create New Trainings',
      contentStep,
      730,
      440,
      [
        {
          text: 'Next',
          class: 'btnDoIt',
          click: () => {
            if (step == 0) {
              step = 1;
              contentStep.html(`<p><b>Step ${step}</b></p>`);
              // ask for period (default to last selected / 1Y)
              ml.UI.addDropdownToValue(
                contentStep,
                'Create new training if previous training was done more than',
                wizardParams,
                'period',
                dateOptions,
                false,
                false,
                () => {
                  globalMatrix.projectStorage.setItem(
                    'trainingPeriodRedo',
                    wizardParams.period,
                  );
                  enableNext();
                },
              );

              // ask for which users
              ml.UI.SelectUserOrGroup.showMultiUserSelect(
                contentStep,
                'Select Users - defaults to the one visible on the screen',
                wizardParams.usersRaw,
                'Select',
                '',
                '',
                true,
                true,
                (selection: string[]) => {
                  wizardParams.user =
                    ml.UI.SelectUserOrGroup.getUsersInSelection(selection);
                  enableNext();
                },
              );

              // ask for processes
              let procs = $('<div>').appendTo(contentStep);
              procs.itemSelection({
                canEdit: true,
                help: 'Processes - defaults to the one visible on the screen',
                preciseSelection: true,
                fieldValue: wizardParams.processes,
                valueChanged: async () => {
                  wizardParams.processes = await procs
                    .getController()
                    .getValueAsync();
                  enableNext();
                },
                parameter: {
                  prefix: 'Selected',
                  buttonName: 'Select',
                  showOnly: catsWithTraining,
                },
              });
            } else if (step == 1) {
              step = 2;
              contentStep.html(`<p><b>Step ${step}</b></p>`);

              $(
                '<span class="baseControlHelp">Trainings to be created</span>',
              ).appendTo(contentStep);
              for (let user of wizardParams.user) {
                contentStep.append(
                  `<h2>${globalMatrix.ItemConfig.getFullName(user)}</h2>`,
                );
                let userTrainings = JSON.parse(wizardParams.processes)
                  .map((p: IReference) => p.to)
                  .filter((process: string) => {
                    if (!this.analysis[process]) return false; // no trainings needed
                    if (!this.analysis[process].users[user]) return false; // no trainings needed for user
                    if (this.analysis[process].users[user].thereIsATraining)
                      return false; // there's already a training
                    if (
                      this.analysis[process].users[user].trainingsDone.length ==
                      0
                    )
                      return true; // no training was done ever
                    if (
                      this.analysis[process].users[user].lastTrainingAgeDays >
                      Number(wizardParams.period)
                    )
                      return true; // training was done a long time ago

                    return false; // a training was already done, not too long ago
                  });
                if (!userTrainings.length) {
                  contentStep.append(`no (more) trainings required`);
                }
                trainingJobs[user] = userTrainings;

                for (let process of userTrainings) {
                  let cb = $(
                    `<div class="checkbox" ><label><input type="checkbox" checked>${process}!</label></div></div>`,
                  ).appendTo(contentStep);

                  $("input[type='checkbox']", cb).change(
                    (event: JQueryMouseEventObject) => {
                      let checked = $(event.delegateTarget).is(':checked');

                      if (checked) {
                        trainingJobs[user].push(process);
                      } else {
                        trainingJobs[user] = trainingJobs[user].filter(
                          (p) => p != process,
                        );
                      }
                    },
                  );
                }
                contentStep.highlightReferences();
              }
            } else if (step == 2) {
              step = 3;
              contentStep.html(`<p><b>Step ${step}</b></p>`);

              // transpose the todo list
              let usersPerProc: IStringStringArrayMap = {};
              for (let user of wizardParams.user) {
                for (let process of trainingJobs[user]) {
                  if (!usersPerProc[process]) usersPerProc[process] = [];
                  usersPerProc[process].push(user);
                }
              }
              let processes = Object.keys(usersPerProc);

              if (processes.length > 2) {
                ml.UI.Progress.Init('Creating Trainings');
              }
              that
                //@ts-ignore
                .createTrainingsRec(processes, usersPerProc, null)
                .then(async () => {
                  ml.UI.showSuccess(
                    'Done creating trainings. Updating view...',
                    1000,
                  );
                  await this.updateTrainings();
                  this.updateVisibility();
                });
              dlg.dialog('close');
            }
          },
        },
        {
          text: 'Cancel',
          class: 'btnCancelIt',
          click: () => {
            dlg.dialog('close');
          },
        },
      ],
      UIToolsConstants.Scroll.Vertical,
      true,
      true,
      () => {
        // close
        dlg.remove();
      },
      () => {
        // open
      },
      () => {
        // resize
      },
    );

    let step = 0;

    function enableNext() {
      let enabled = false;
      if (step == 0) {
        enabled = true;
      } else if (step == 1) {
        enabled =
          wizardParams.period != '' &&
          wizardParams.processes != '' &&
          wizardParams.user.length != 0;
      }

      ml.UI.setEnabled(dlg.parent().find('.btnDoIt'), enabled);
    }

    enableNext();
  }

  private sendReminderWizards() {
    let that = this;

    let dlg = $('<div>').appendTo('body');
    let contentStep = $('<div>');

    // filled by wizard
    let emailJobs: IStringStringArrayMap = {};

    $(`<p>Use this wizard to send reminders for the trainings which need to be done. </p>
        <ul><li>Step 1: Decide for which users and processes and reminders should be created</li>
        <li>Step 2: Acknowledge the reminders to be send</li>
        <li>Step 3: Send the emails</li>
        </ul>`).appendTo(contentStep);

    // currently visible procs and users
    let selectedUsers = $('th:visible', this.headerRow)
      .toArray()
      .map((x) => $(x).data('user'));
    let selectedProcs = $('tr:visible', this.leftBody)
      .toArray()
      .map((x) => $(x).data('itemid'));

    // all cats with trainings
    let catsWithTraining = this.getCatsWithTrainings();

    // params needed
    let wizardParams = {
      usersRaw: selectedUsers,
      user: ml.UI.SelectUserOrGroup.getUsersInSelection(selectedUsers),
      processes: JSON.stringify(
        selectedProcs.map((p) => {
          return { to: p };
        }),
      ),
    };

    ml.UI.showDialog(
      dlg,
      'Send emails',
      contentStep,
      730,
      440,
      [
        {
          text: 'Next',
          class: 'btnDoIt',
          click: () => {
            if (step == 0) {
              step = 1;
              contentStep.html(`<p><b>Step ${step}</b></p>`);
              // ask for which users
              ml.UI.SelectUserOrGroup.showMultiUserSelect(
                contentStep,
                'Select Users - defaults to the one visible on the screen',
                wizardParams.usersRaw,
                'Select',
                '',
                '',
                true,
                true,
                (selection: string[]) => {
                  wizardParams.user =
                    ml.UI.SelectUserOrGroup.getUsersInSelection(selection);
                  enableNext();
                },
              );

              // ask for processes
              let procs = $('<div>').appendTo(contentStep);
              procs.itemSelection({
                canEdit: true,
                help: 'Processes - defaults to the one visible on the screen',
                preciseSelection: true,
                fieldValue: wizardParams.processes,
                valueChanged: async () => {
                  wizardParams.processes = await procs
                    .getController()
                    .getValueAsync();
                  enableNext();
                },
                parameter: {
                  prefix: 'Selected',
                  buttonName: 'Select',
                  showOnly: catsWithTraining,
                },
              });
            } else if (step == 1) {
              step = 2;
              contentStep.html(`<p><b>Step ${step}</b></p>`);
              $(
                '<span class="baseControlHelp">Emails to be send</span>',
              ).appendTo(contentStep);
              for (let user of wizardParams.user) {
                contentStep.append(
                  `<h2>${globalMatrix.ItemConfig.getFullName(user)}</h2>`,
                );
                let userMails = JSON.parse(wizardParams.processes)
                  .map((p: IReference) => p.to)
                  .filter((process: string) => {
                    if (!this.analysis[process]) return false; // no trainings needed
                    if (!this.analysis[process].users[user]) return false; // no trainings needed for user
                    if (this.analysis[process].users[user].thereIsATraining)
                      return true; // there's a training open
                    return false; // no need for email
                  });
                if (!userMails.length) {
                  contentStep.append(`no (more) trainings to do / no mail`);
                }
                emailJobs[user] = userMails;

                for (let process of userMails) {
                  let cb = $(
                    `<div class="checkbox" ><label><input type="checkbox" checked>${process}!</label></div></div>`,
                  ).appendTo(contentStep);

                  $("input[type='checkbox']", cb).change(
                    (event: JQueryMouseEventObject) => {
                      let checked = $(event.delegateTarget).is(':checked');

                      if (checked) {
                        emailJobs[user].push(process);
                      } else {
                        emailJobs[user] = emailJobs[user].filter(
                          (p: any) => p != process,
                        );
                      }
                    },
                  );
                }
                contentStep.highlightReferences();
              }
            } else if (step == 2) {
              step = 3;
              contentStep.html(`<p><b>Step ${step}</b></p>`);

              let sendTo: string[] = [];
              let sendWhat: string[] = [];

              for (let user of wizardParams.user) {
                if (emailJobs[user] && emailJobs[user].length) {
                  let body = '<ul>';
                  for (let process of emailJobs[user]) {
                    body +=
                      "<li><a href='" +
                      globalMatrix.matrixBaseUrl +
                      '/pub/' +
                      matrixSession.getProject() +
                      '/?show=' +
                      process +
                      "'>" +
                      process +
                      '</a> ' +
                      app.getItemTitle(process) +
                      '</li>';
                  }

                  body += '</ul>';

                  let message = ml.Mail.getCannedMessage(
                    'training_reminder',
                    user,
                    '',
                    undefined,
                    body,
                  );

                  sendTo.push(user);
                  sendWhat.push(message);
                }
              }

              ml.Mail.sendMails(sendTo, 'Training Reminder', sendWhat);
              dlg.dialog('close');
            }
          },
        },
        {
          text: 'Cancel',
          class: 'btnCancelIt',
          click: () => {
            dlg.dialog('close');
          },
        },
      ],
      UIToolsConstants.Scroll.Vertical,
      true,
      true,
      () => {
        // close
        dlg.remove();
      },
      () => {
        // open
      },
      () => {
        // resize
      },
    );

    let step = 0;

    function enableNext() {
      let enabled = false;
      if (step == 0) {
        enabled = true;
      } else if (step == 1) {
        enabled = wizardParams.processes != '' && wizardParams.user.length != 0;
      }
      ml.UI.setEnabled(dlg.parent().find('.btnDoIt'), enabled);
    }

    enableNext();
  }

  private addDonut(anchor: JQuery, heading: string, slices: IPieSlice[]) {
    c3.generate({
      bindto: anchor[0],
      data: {
        // iris data from R
        columns: slices.map((slice) => [slice.text, slice.count]),
        type: 'donut',
      },
      donut: {
        title: heading,
      },
    });
  }

  private getCatsWithTrainings() {
    let catsWithTraining: string[] = [];
    $.each(globalMatrix.ItemConfig.getQMSConfig().publications, (idx, pub) => {
      $.each(pub.rules, (jdx, rule) => {
        catsWithTraining.push(rule.category);
      });
    });
    return catsWithTraining;
  }

  protected async createTrainingsRec(
    items: string[],
    userMap: IStringStringArrayMap,
    user: string,
  ): Promise<void> {
    for (let idx = 0; idx < items.length; idx++) {
      if (items.length > 2) {
        ml.UI.Progress.Update((idx * 100) / items.length);
      }

      let item = items[idx];
      let users = userMap ? userMap[item] : [user];
      await NotificationsBL.createNotification(
        users,
        matrixSession.getProject(),
        item,
        'Training required',
        'needTraining',
        //@ts-ignore
        null,
      );
      let todosForItem = await NotificationsBL.getAllNotificationForItem(
        matrixSession.getProject(),
        item,
      );
      this.trainingTodos.push(...todosForItem.todos);
      this.trainingTodos = Array.from(new Set<XRTodo>(this.trainingTodos));
      this.trainingTodosPerItem[item] = todosForItem.todos;
    }
    if (items.length > 2) {
      ml.UI.Progress.SuccessHide('Done creating trainings', 1000);
    } else {
      ml.UI.showSuccess('Done creating trainings', 1000);
    }
  }
}
interface IPieSlice {
  text: string;
  count: number;
}

sdkInstance.plugins.register(new QMSTraining());
